var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.2037 25.6698L60.1578 18.7494L60.6212 15.8355C47.9491 4.36847 27.805 5.6687 16.3813 18.5485C13.2085 22.1258 10.8545 26.5856 9.59914 31.191L12.0898 30.8418L25.9975 28.5592L27.0713 27.4667C33.2578 20.7052 43.7181 19.7956 50.8613 25.5485L53.2037 25.6698Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.064 30.9873C68.4657 25.1296 65.1839 19.8636 60.6212 15.8355L50.8613 25.5485C52.8953 27.2025 54.5254 29.2942 55.6286 31.6666C56.7318 34.0389 57.2793 36.6295 57.2297 39.2431V40.9672C62.0265 40.9672 65.9162 44.8374 65.9162 49.6114C65.9162 54.3857 62.0269 58.1588 57.2297 58.1588H39.8325L38.1244 60.0042V70.3725L39.8325 71.9993H57.2294C69.7075 72.096 79.9021 62.2051 79.9993 49.7874C80.0283 46.0816 79.1365 42.4262 77.4031 39.1463C75.6697 35.8663 73.1486 33.0636 70.064 30.9873Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4594 71.9996H39.8322L39.8325 58.1588H22.4594C21.2296 58.1587 20.0144 57.8937 18.8972 57.382L16.4326 58.1346L9.42977 65.055L8.81977 67.4104C12.7469 70.3613 17.5385 72.0208 22.4594 71.9996Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4594 27.1022C9.98133 27.1765 -0.0739649 37.3035 0.000409943 49.7215C0.0209246 53.1434 0.826031 56.5155 2.35439 59.581C3.88275 62.6464 6.09403 65.3242 8.81977 67.4104L18.8972 57.382C14.5254 55.416 12.5823 50.2962 14.5576 45.9455C16.5326 41.5948 21.6782 39.6611 26.0497 41.6265C27.9762 42.4927 29.5192 44.0283 30.3894 45.9455L40.4669 35.9168C38.3518 33.165 35.6257 30.9374 32.5018 29.4082C29.3778 27.8791 25.9408 27.0898 22.4594 27.1022Z",
    fill: "#FBBC05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.d90922422d1035a36ba8973edbca7192.svg";
export { ForwardRef as ReactComponent };